module.exports = __webpack_public_path__ + "static/media/vision.b3f57da9.png";